import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { ProjectIndividual } from "../canonical";
import { formatDateOnly, dateToMillis } from "../utils/ProjectDetailsUtilities";

interface ProjectDetailsDashScheduleProps {
  selectedProject?: ProjectIndividual;
}
const ONE_DAY = 1000 * 60 * 60 * 24;

const ProjectDetailsDashSchedule: React.FC<ProjectDetailsDashScheduleProps> = ({
  selectedProject,
}) => {
  const rawStartDate = selectedProject?.project?.startDateTime;
  const rawEndDate = selectedProject?.project?.endDateTime;

  const startMs = dateToMillis(rawStartDate);
  const endMs = dateToMillis(rawEndDate);

  const validDates = startMs !== null && endMs !== null;
  const totalDays = validDates ? (endMs - startMs) / ONE_DAY : 0;
  const daysPassed = validDates
    ? Math.floor((Date.now() - startMs) / ONE_DAY)
    : 0;
  const daysPct = validDates ? Math.floor((daysPassed * 100) / totalDays) : 0;
  const meterPct = Math.min(daysPct, 100);
  const meterColor = daysPct > 100 ? "error.main" : "primary";

  return (
    <>
      {validDates && selectedProject?.project && (
        <Stack
          sx={{
            backgroundColor: "table.header",
            p: 2,
            pt: 2.5,
            flex: 1,
            justifyContent: "space-between",
            minHeight: 0,
          }}
        >
          <Stack direction="row" sx={{ mb: 2 }}>
            <Box display="flex" alignItems="baseline">
              <Typography variant="h6">{daysPct}%</Typography>
              <Typography variant="caption" sx={{ ml: 1 }}>
                passed ({daysPassed}/{Math.round(totalDays)} days)
              </Typography>
            </Box>
          </Stack>
          <Stack sx={{ flex: 1, justifyContent: "flex-end" }}>
            <Stack
              direction="row"
              sx={{ justifyContent: "space-between", mb: 1 }}
            >
              <Typography variant="caption">
                Start Date: {formatDateOnly(rawStartDate) || "—"}
              </Typography>
              <Typography variant="caption">
                End Date: {formatDateOnly(rawEndDate) || "—"}
              </Typography>
            </Stack>
            <LinearProgress
              variant="determinate"
              value={meterPct}
              sx={() => ({
                display: "flex",
                height: "10px",
                "& .MuiLinearProgress-bar": { backgroundColor: meterColor },
              })}
              aria-label="Service engagement schedule progress"
            />
          </Stack>
        </Stack>
      )}
      {(!validDates || !selectedProject?.project) && (
        <Box display="flex" flex="1" alignItems="center">
          <Typography sx={{ p: 2 }}>
            Unable to locate service engagement dates
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ProjectDetailsDashSchedule;
